__turbopack_context__.v({
  "className": "geist_a7695b8e-module__Entzca__className",
});
